import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrentUserState } from './current-user.reducer';

export const selectCurrentUserState = createFeatureSelector<CurrentUserState>('currentUser');

export const getCurrentUser = createSelector(
  selectCurrentUserState,
  (state: CurrentUserState) => {
    console.log('Selector getCurrentUser called. Current user:', state.currentUser);
    return state.currentUser;
  }
);

